module.exports = __webpack_public_path__ + "img/ai-experience.af9d0007.png";